export default __webpack_public_path__ + "static/media/mc.3a3d3636.svg";